(() => {
  const root = document.querySelector('[data-legal-nl-popup]');
  if (!root) return;

  const dialog = root.querySelector('.legal-nl-popup__dialog');
  const content = root.querySelector('.legal-nl-popup__content');
  const form = root.querySelector('.legal-nl-popup__form');
  const email = root.querySelector('.legal-nl-popup__email');
  const tags = root.querySelector('[data-legal-nl-tags]');
  const scratch = root.querySelector('[data-legal-nl-scratch]');
  const canvas = scratch?.querySelector('canvas');
  const reward = scratch?.querySelector('.legal-nl-popup__reward');
  const rewardNext = root.querySelector('[data-legal-nl-gift-next]');
  const formatOptions = [...root.querySelectorAll('input[name="legal_nl_format"]')];
  const validFormats = new Set(['capsules', 'dosettes']);
  const key = 'legal_nl_popup_v1';
  const pendingKey = `${key}_pending`;
  const seenKey = `${key}_seen`;
  const designMode = root.dataset.designMode === 'true';
  const urlPreview = new URLSearchParams(window.location.search).get('legal_nl_preview');
  const isPreview = designMode || urlPreview === 'gift';
  let previouslyFocused = null;
  let previousOverflow = '';
  let isOpen = false;
  let isRevealed = false;
  let scratchStarted = false;
  let strokeCount = 0;
  let keyboardStroke = 0;
  let selectedFormat = '';

  const read = (storage, name) => {
    try { return storage.getItem(name); } catch (_) { return null; }
  };
  const write = (storage, name, value) => {
    try { storage.setItem(name, value); } catch (_) { /* Private mode may block storage. */ }
  };
  const remove = (storage, name) => {
    try { storage.removeItem(name); } catch (_) { /* Nothing to clear. */ }
  };
  const parse = (value) => {
    try { return JSON.parse(value); } catch (_) { return null; }
  };
  const track = (event, details = {}) => {
    if (!isPreview) window.LegalTracking?.track(event, { surface: 'nl_popup', variant: 'gift', ...details });
  };

  const pending = parse(read(window.sessionStorage, pendingKey));
  const recentPending = pending && Date.now() - pending.at < 30 * 60 * 1000 &&
    validFormats.has(pending.format);

  const setStep = (step) => {
    root.querySelectorAll('[data-legal-nl-step]').forEach((panel) => {
      panel.hidden = panel.dataset.legalNlStep !== step;
    });
    dialog.scrollTop = 0;
    content.scrollTop = 0;
    const number = step === 'email' ? 2 : step === 'success' ? 3 : 1;
    root.dataset.step = step;
    const heading = root.querySelector(`[data-legal-nl-step="${step}"] .legal-nl-popup__title`);
    if (heading) dialog.setAttribute('aria-labelledby', heading.id);
    if (step === 'gift' && !isRevealed) requestAnimationFrame(initScratch);
    track('nl_popup_step_view', { step: String(number), format: selectedFormat || undefined });
  };

  const open = (step = 'gift') => {
    if (isOpen) return;
    if (step === 'gift' && !isPreview) write(window.localStorage, seenKey, '1');
    previouslyFocused = document.activeElement;
    previousOverflow = document.body.style.overflow;
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    isOpen = true;
    setStep(step);
    dialog.focus();
    track('nl_popup_impression');
  };

  const close = () => {
    if (!isOpen) return;
    root.hidden = true;
    document.body.style.overflow = previousOverflow;
    isOpen = false;
    track('nl_popup_close');
    previouslyFocused?.focus?.();
  };

  const reveal = () => {
    if (isRevealed) return;
    isRevealed = true;
    scratch.classList.add('is-ready');
    scratch.classList.add('is-revealed');
    canvas.hidden = true;
    reward.removeAttribute('aria-hidden');
    rewardNext.disabled = false;
    if (document.activeElement === canvas) rewardNext.focus();
    track('nl_popup_reward_revealed');
  };

  function initScratch() {
    if (!canvas || isRevealed || scratch.offsetWidth === 0) return;
    const ratio = Math.min(window.devicePixelRatio || 1, 2);
    const width = Math.round(scratch.clientWidth * ratio);
    const height = Math.round(scratch.clientHeight * ratio);
    if (!width || !height) return;
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d', { willReadFrequently: true });
    if (!context) {
      reveal();
      return;
    }
    context.globalCompositeOperation = 'source-over';
    context.fillStyle = 'rgba(239, 159, 170, 0.62)';
    context.fillRect(0, 0, width, height);
    context.strokeStyle = 'rgba(166, 53, 59, 0.2)';
    context.lineWidth = 2 * ratio;
    for (let x = -height; x < width + height; x += 22 * ratio) {
      context.beginPath();
      context.moveTo(x, 0);
      context.lineTo(x + height, height);
      context.stroke();
    }
    context.fillStyle = 'rgba(254, 239, 234, 0.92)';
    context.beginPath();
    if (typeof context.roundRect === 'function') {
      context.roundRect(width * 0.12, height * 0.32, width * 0.76, height * 0.38, 12 * ratio);
    } else {
      context.rect(width * 0.12, height * 0.32, width * 0.76, height * 0.38);
    }
    context.fill();
    context.fillStyle = '#a6353b';
    context.textAlign = 'center';
    context.font = `900 ${Math.round(23 * ratio)}px Archivo Legal, Arial, sans-serif`;
    context.fillText('GRATTEZ ICI', width / 2, height / 2 + 6 * ratio);
    context.font = `800 ${Math.round(11 * ratio)}px Archivo Legal, Arial, sans-serif`;
    context.fillText('NON, CE N’EST PAS UN TICKET DE LOTO', width / 2, height / 2 + 28 * ratio);
    scratch.classList.add('is-ready');
  }

  const point = (event) => {
    const rect = canvas.getBoundingClientRect();
    return {
      x: (event.clientX - rect.left) * canvas.width / rect.width,
      y: (event.clientY - rect.top) * canvas.height / rect.height,
    };
  };

  const erasedEnough = () => {
    try {
      const context = canvas.getContext('2d', { willReadFrequently: true });
      const image = context.getImageData(0, 0, canvas.width, canvas.height).data;
      let clear = 0;
      let sampled = 0;
      for (let y = 4; y < canvas.height - 4; y += 9) {
        for (let x = 4; x < canvas.width - 4; x += 9) {
          clear += image[(y * canvas.width + x) * 4 + 3] < 50 ? 1 : 0;
          sampled += 1;
        }
      }
      return sampled > 0 && clear / sampled >= 0.38;
    } catch (_) {
      return strokeCount >= 12;
    }
  };

  canvas?.addEventListener('pointerdown', (event) => {
    if (isRevealed) return;
    event.preventDefault();
    canvas.setPointerCapture?.(event.pointerId);
    scratchStarted = true;
    const context = canvas.getContext('2d');
    const start = point(event);
    context.globalCompositeOperation = 'destination-out';
    context.lineCap = 'round';
    context.lineJoin = 'round';
    context.lineWidth = 38 * Math.min(window.devicePixelRatio || 1, 2);
    context.beginPath();
    context.moveTo(start.x, start.y);
    context.lineTo(start.x + 0.1, start.y + 0.1);
    context.stroke();
  });

  canvas?.addEventListener('pointermove', (event) => {
    if (!scratchStarted || isRevealed) return;
    event.preventDefault();
    const end = point(event);
    const context = canvas.getContext('2d');
    context.lineTo(end.x, end.y);
    context.stroke();
    strokeCount += 1;
  });

  const finishScratch = () => {
    if (!scratchStarted) return;
    scratchStarted = false;
    if (erasedEnough()) reveal();
  };
  canvas?.addEventListener('pointerup', finishScratch);
  canvas?.addEventListener('pointercancel', finishScratch);

  canvas?.addEventListener('keydown', (event) => {
    if (isRevealed || !['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', ' ', 'Enter'].includes(event.key)) return;
    event.preventDefault();
    if (event.key === ' ' || event.key === 'Enter') {
      reveal();
      return;
    }
    const context = canvas.getContext('2d');
    if (!context) return;
    const rows = [0.18, 0.36, 0.54, 0.72, 0.9];
    const y = canvas.height * rows[keyboardStroke % rows.length];
    context.globalCompositeOperation = 'destination-out';
    context.lineCap = 'round';
    context.lineWidth = 34 * Math.min(window.devicePixelRatio || 1, 2);
    context.beginPath();
    context.moveTo(canvas.width * 0.08, y);
    context.lineTo(canvas.width * 0.92, y);
    context.stroke();
    keyboardStroke += 1;
    if (erasedEnough()) reveal();
  });

  rewardNext.addEventListener('click', () => {
    if (!isRevealed) return;
    setStep('email');
    formatOptions[0]?.focus();
  });

  formatOptions.forEach((option) => option.addEventListener('change', () => {
    if (!option.checked || !validFormats.has(option.value)) return;
    selectedFormat = option.value;
    track('nl_popup_format_selected', { format: selectedFormat });
  }));

  root.querySelector('[data-legal-nl-back]').addEventListener('click', () => {
    setStep('gift');
    (isRevealed ? rewardNext : canvas)?.focus();
  });
  root.querySelectorAll('[data-legal-nl-close]').forEach((button) => button.addEventListener('click', close));

  root.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('button:not([disabled]), input:not([disabled]), [tabindex="0"]')]
      .filter((item) => !item.closest('[hidden]') && item.getClientRects().length);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  form.addEventListener('submit', (event) => {
    selectedFormat = formatOptions.find((option) => option.checked)?.value || '';
    if (!validFormats.has(selectedFormat)) {
      event.preventDefault();
      formatOptions[0]?.focus();
      return;
    }
    if (!form.checkValidity()) return;
    tags.value = `newsletter,legal_nl_popup,legal_nl_cadeau,legal_nl_format_${selectedFormat}`;
    write(window.sessionStorage, pendingKey, JSON.stringify({ format: selectedFormat, at: Date.now() }));
    track('nl_popup_submit', { format: selectedFormat });
  });

  if (recentPending && (root.querySelector('[data-legal-nl-server-success]') || root.querySelector('[data-legal-nl-error]'))) {
    selectedFormat = pending.format;
    const selectedOption = formatOptions.find((option) => option.value === selectedFormat);
    if (selectedOption) selectedOption.checked = true;
    if (root.querySelector('[data-legal-nl-server-success]')) {
      remove(window.sessionStorage, pendingKey);
      write(window.localStorage, `${key}_joined`, String(Date.now()));
      root.setAttribute('data-openai-ads-lead', '');
      open('success');
      track('newsletter_signup_success', { format: selectedFormat });
    } else if (root.querySelector('[data-legal-nl-error]')) {
      open('email');
      email.focus();
    }
  } else if (isPreview) {
    open();
  } else if (!read(window.localStorage, `${key}_joined`) &&
    !read(window.localStorage, seenKey) &&
    !read(window.localStorage, `${key}_dismiss_until`)) {
    window.setTimeout(() => open(), Math.max(0, Number(root.dataset.delay) || 0) * 1000);
  }
})();
